import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcCaretRight = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4.5 2.25L8.25 6L4.5 9.75",
  stroke: "#B8B8B8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
})), "IcCaretRight");

export { IcCaretRight };
//# sourceMappingURL=ic-caret-right.js.map
